import { render, staticRenderFns } from "./project-step-tasks.vue?vue&type=template&id=0aa571c5&"
import script from "./project-step-tasks.vue?vue&type=script&lang=js&"
export * from "./project-step-tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports